import fetch from './fetch'
import {
   uuid
} from './utils'
const SOFT_VERSION = 'V1.0.1';
/**
 * 验证码快捷登录
 * @param account
 * @param checkCode
 * @returns {Promise<*>}
 */
export const phoneLogin = (account, checkCode) => fetch('/v1/user/auto_sign_in', {
    phone: account,
    code: checkCode,
});

/**
 * 手机验证码
 * @param account
 * @param imagecode
 * @returns {Promise<*>}
 */
export const getCheckCode = (account, imgcode) => {
    let params = {
        version: SOFT_VERSION,
        uuid: uuid(),
        phone: account,
        code: imgcode
    }
    return fetch('/v1/sms', params);
}

/** 
 * 授权信息查询
 * @param uuid
 * @returns {Promise<*>}
*/
export const authQuery = (uuid) => {
    let params = {
        version: SOFT_VERSION,
        uuid: uuid,
    }
    return fetch('/v1/user/auth_query', params);
}

/** 
 * 授权信息查询
 * @param uuid
 * @returns {Promise<*>}
 */
export const verifyToken = (token) => {
    let params = {
        version: SOFT_VERSION,
        token: token,
    }
    return fetch('/v1/user/verify_token', params);
}







